import { render, staticRenderFns } from "./ArticlesModal.vue?vue&type=template&id=603bb2fe&scoped=true"
import script from "./ArticlesModal.vue?vue&type=script&lang=js"
export * from "./ArticlesModal.vue?vue&type=script&lang=js"
import style0 from "./ArticlesModal.vue?vue&type=style&index=0&id=603bb2fe&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603bb2fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('603bb2fe')) {
      api.createRecord('603bb2fe', component.options)
    } else {
      api.reload('603bb2fe', component.options)
    }
    module.hot.accept("./ArticlesModal.vue?vue&type=template&id=603bb2fe&scoped=true", function () {
      api.rerender('603bb2fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/AppPage/HundredDayOathDetail/components/ArticlesModal.vue"
export default component.exports